import { render, staticRenderFns } from "./messageDetailDialog.vue?vue&type=template&id=1e380b81&scoped=true"
import script from "./messageDetailDialog.vue?vue&type=script&lang=js"
export * from "./messageDetailDialog.vue?vue&type=script&lang=js"
import style0 from "./messageDetailDialog.vue?vue&type=style&index=0&id=1e380b81&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e380b81",
  null
  
)

export default component.exports